import {SectionUrl} from '@wix/wixstores-client-storefront-sdk/dist/src/viewer-script/site-store/SiteStore';

export function getProductPageSectionUrl(sectionUrl: SectionUrl, baseUrl: string): string {
  if (sectionUrl.prefix) {
    return `${baseUrl}/${sectionUrl.prefix}`;
  }

  return sectionUrl.url;
}
